import { render } from "./MoreORLess.vue?vue&type=template&id=7ac4037a&scoped=true"
import script from "./MoreORLess.vue?vue&type=script&lang=js"
export * from "./MoreORLess.vue?vue&type=script&lang=js"

import "./MoreORLess.vue?vue&type=style&index=0&id=7ac4037a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac4037a"]])

export default __exports__